import { ILocale } from 'types';
import { trackEvent } from '..';
import { PRODUCT_EVENT } from '../constants';
import { getIDetailsGeneric } from './genericEvents';

interface EventFavoriteProps {
	cruise: any;
	cruiseIndex: number;
	resultsLength: number;
	locale: ILocale;
	isSaved: boolean;
	srcComponent: string;
}

const trackOnFavoriteAction = ({ cruise, cruiseIndex, resultsLength, locale, isSaved, srcComponent }: EventFavoriteProps) => {
	const action = `${srcComponent}: ${isSaved ? PRODUCT_EVENT.favorite.added : PRODUCT_EVENT.favorite.removed}`;

	const event = {
		...getIDetailsGeneric({ cruise, cruiseIndex, resultsLength, locale, action }),
		productEvent: [isSaved ? PRODUCT_EVENT.favorite.added : PRODUCT_EVENT.favorite.removed],
	};

	trackEvent(event);
};

export { trackOnFavoriteAction };
